import { func, string } from 'prop-types';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useWindowInnerWidth from '@hooks/useWindowInnerWidth';

import DateRangeRightSidePanel from '@features/filter/v2/salesFunnel/DateRangeRightSidePanel';

import { clearGlobalFilter, storeSelectedFilterCheckboxType } from '@store/actions/FilterAction';
import { setExploreProductsSourceType } from '@store/actions/trend-research/TrendResearchAction';
import {
	useExploreProductsSource,
	useSelectedBrands,
	useSelectedInluencers
} from '@store/reducers/trend-research/TrendResearchReducer';

import { trendResearchDateRangePresets } from '@utils/Util';

import { BRAND_OR_INFLUENCER_SLIDER_RESPONSIVE, getSlidesToShowNumber } from '@/constants/constant';

const TrendTopFilter = ({ type, title = '', toggleImageSearchModal }) => {
	const dispatch = useDispatch();
	const { width } = useWindowInnerWidth();
	const selectedBrands = useSelectedBrands();
	const selectedInluencers = useSelectedInluencers();
	const filterData = useSelector((store) => store.filterFieldStore);
	const selectedField = useSelector((store) => store.slectedCheckBoxFieldStore);
	const exploreProductSource = useExploreProductsSource();

	const toggleCalendar = () => {
		if (selectedField?.selectedCheckboxField === 'DATE_RANGE') {
			dispatch(storeSelectedFilterCheckboxType(null));
		} else {
			dispatch(storeSelectedFilterCheckboxType('DATE_RANGE'));
		}
	};

	const setProductsSource = (data) => {
		dispatch(setExploreProductsSourceType(data));
	};

	const sliderSlides = getSlidesToShowNumber(width, BRAND_OR_INFLUENCER_SLIDER_RESPONSIVE);

	const isShowSliderController =
		type === 'Instagram'
			? selectedInluencers.length > sliderSlides
			: selectedBrands.length > sliderSlides;

	return (
		<div
			className={`section-title d-flex align-items-center justify-content-between ${
				type !== 'Explore' ? 'pt-3 pb-3' : ''
			}`}
		>
			<p className="semibold-16 gray_dark_01">{title}</p>
			<div className="product-search-action d-flex align-items-center">
				{type === 'Explore' && (
					<div className="search-img cursor-pointer" onClick={() => toggleImageSearchModal(true)}>
						<img src={`${process.env.PUBLIC_URL}/icons/camera.svg`} alt="" />
					</div>
				)}
				{type === 'Explore' && (
					<div className="sort-button">
						<select
							name=""
							id=""
							className="border-0"
							value={exploreProductSource}
							onChange={(e) => setProductsSource(e.target.value)}
						>
							<option value="BRAND">Brand</option>
							<option value="INSTAGRAM">Instagram</option>
						</select>
					</div>
				)}
				<div
					className={`calender pb-2 ${
						type !== 'Explore' && isShowSliderController ? 'no-slider' : ''
					}`}
				>
					<div className="cursor-pointer d-flex align-items-center justify-content-between">
						<div
							onClick={toggleCalendar}
							className="w-100 cursor-pointer d-flex align-items-center justify-content-between"
						>
							<p className="regular-14 gray_dark_01 weight-400 pr-2">
								{filterData['dateRange']?.[0]?.value}
							</p>
							{!filterData['dateRange']?.[0]?.value && (
								<img src={`${process.env.PUBLIC_URL}/icons/calendar.svg`} alt="" />
							)}
						</div>

						{filterData['dateRange']?.[0]?.value && (
							<img
								className="cursor-pointer"
								src={`${process.env.PUBLIC_URL}/icons/close.svg`}
								alt=""
								onClick={() => dispatch(clearGlobalFilter())}
							/>
						)}
					</div>
					{selectedField?.selectedCheckboxField === 'DATE_RANGE' && (
						<div className="trending-calendar shadow-8dp p-3">
							<DateRangeRightSidePanel
								type="DATE_RANGE"
								presets={trendResearchDateRangePresets}
							/>
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

TrendTopFilter.propTypes = {
	type: string.isRequired,
	title: string,
	toggleImageSearchModal: func
};

export default TrendTopFilter;
